<script>
	import options from './BasketComponent.options'
	export default options
</script>

<template>
  <ul class="nlx-basket-component" :class="{'nlx-basket-component--receipt':modifyCartLayout}">
		<template v-if="cartSpinnerSpinning">
			<div class="nlx-loading-spinner-overlay">
				<div class="nlx-loading-spinner"></div>
			</div>
		</template>

			<template v-if="hasItemsInCart">
				<li v-for="(orderLine, index) in orderLines" :key="index" class="nlx-basket-component__list-item" :class="{'nlx-basket-component__list-item--receipt':modifyCartLayout}">
					<BasketItemSpot :location="location" :modifyCartLayout="modifyCartLayout" :orderLine="orderLine" :customerServiceReasons="customerServiceReasons"/>
				</li>
			</template>
			<template  v-else>
				{{getLabel('cart_is_empty')}}
			</template>


	</ul>
</template>
